(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxTranslationEditor', {
		bindings: {
			localizedValue: '=',
			supportedLanguages: '<',
		},
		controller: MxTranslationEditorCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-translation-editor/mx-translation-editor.html',
	});

	MxTranslationEditorCtrl.$inject = ['mx.shell.SidePanelService', 'mx.SolutionBuilderAgent.TranslationService', 'mx.internationalization', 'mx.shell.NotificationService'];

	function MxTranslationEditorCtrl(sidePanelService, translationService, internationalization, notificationService) {
		var vm = this;

		vm.$onInit = function () {
			vm.hideClick = function () {
				sidePanelService.closeView(sidePanelService.currentView);
			};

			vm.saveClick = function () {
				if (!vm.localizedValue.id || !vm.prepareProperty) {
					throw new Error('Inconsistent model state.');
				}

				var property = vm.prepareProperty(vm.localizedValue.id);
				if (
					!property.translations.some(function (t) {
						return t.lcid === 9;
					})
				) {
					property.translations.push(new mx.SolutionBuilderAgent.LocalizationPropertyTranslation({ Value: property.value, Lcid: 9 }));
				}

				translationService.updateTranslation(vm.localizedValue.id, property).then(function () {
					notificationService.success(internationalization.get('solutionBuilderAgent.layouts.dialog.dialog-content.object-saved'));
					vm.hideClick();
				});
			};
		};

		return vm;
	}
})();
